
;var cwMjs=window.cwMjs || {};

cwMjs.index={
    init: function () {
        var $slide=$('.hot-list .flexslider');

        $slide.flexslider({
            slideshow:false,
            animationLoop:true,
            animation:'slide',
            directionNav:false
        });
    }
};
